import {disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks} from "body-scroll-lock";

function CustomerDrawer() {
  this.selectors = {
    drawer: "[data-customer-drawer]",
    drawerScrollableContent: "[data-customer-drawer-content]",
    drawerOpen: "[data-customer-drawer-open]",
    drawerClose: "[data-customer-drawer-close]",
    forms: "[data-customer-form]",
    contentToggler: "[data-toggle-content]",
    content: "[data-drawer-content]",
    preferencesOption: "[data-preferences-option]",
    preferencesInput: "[data-customer-tags]",
    ordersCard: ".js-order-card",
    ordersCardList: ".js-orders-cards-list",
    containerForOrderData: ".js-insert-order-content",
    singleOrderName: ".js-single-order-name",
    showResetPasswordLink: ".js-show-reset-password",
    showLoginFormLink: ".js-show-login-form",
    resetPasswordForm: "#CustomerFormRecoverPassword",
    loginForm: "#CustomerFormLogin",
    loginErrors: ".js-customer-login-form-error",
    resetPasswordSuccess: ".js-customer-reset-form-success",
    resetPasswordError: ".js-customer-reset-form-error",
    pagePasswordError: ".js-default-reset-password-error"
  };

  this.modifiers = {
    drawerOpen: "customer-drawer--open",
    contentVisible: "customer-drawer-content--visible",
    drawerPreloader: "customer-drawer--loader"
  };

  this.drawer = document.querySelector(this.selectors.drawer);

  if (!this.drawer) {
    return null;
  }

  this.drawerScrollableContent = this.drawer.querySelector(this.selectors.drawerScrollableContent);

  let content = this.drawer.querySelectorAll(this.selectors.content);

  this.content = [...content].reduce((contents, content) => {
    return {
      ...contents,
      [content.dataset.drawerContent]: content
    };
  }, {});

  let forms = this.drawer.querySelectorAll(this.selectors.forms);

  this.forms = [...forms].reduce((forms, form) => {
    return {
      ...forms,
      [form.dataset.customerForm]: form
    };
  }, {});

  this.init();
}

CustomerDrawer.prototype.init = function () {
  this.initDrawerEvents();

  this.initLoginForm();
  this.initRegisterForm();

  this.getOrderData();
};

CustomerDrawer.prototype.initDrawerEvents = function () {
  const openDrawerHandler = (event) => {
    const openButton = event.target.closest(this.selectors.drawerOpen);

    if (!openButton) {
      return null;
    }

    event.preventDefault();

    const contentToShowName = openButton.dataset.customerDrawerOpen;

    if (contentToShowName !== "") { // open existing drawer content
      let contentToShow = [...this.drawer.querySelectorAll(this.selectors.content)].filter((element) => {
        return element.dataset.drawerContent === contentToShowName;
      });

      if (contentToShow) {
        this.drawer.querySelectorAll(this.selectors.content).forEach((element) => {
          element.classList.remove(this.modifiers.contentVisible);
        });

        contentToShow[0].classList.add(this.modifiers.contentVisible);
      }
    }

    disableBodyScroll(this.drawerScrollableContent);
    this.drawer.classList.add(this.modifiers.drawerOpen);
  };

  const closeDrawerHandler = (event) => {
    const closeButton = event.target.closest(this.selectors.drawerClose);

    if (!closeButton) {
      return null;
    }

    event.preventDefault();

    enableBodyScroll(this.drawerScrollableContent);
    this.drawer.classList.remove(this.modifiers.drawerOpen);
  };

  const toggleFormHandler = (event) => {
    const contentToggler = event.target.closest(this.selectors.contentToggler);

    if (!contentToggler) {
      return null;
    }

    event.preventDefault();

    let newContentType = contentToggler.dataset.toggleContent;

    let previousContent = contentToggler.closest(this.selectors.content);
    let newContent = this.content[newContentType];

    if (!newContent) {
      return null;
    }

    previousContent.classList.remove(this.modifiers.contentVisible);
    newContent.classList.add(this.modifiers.contentVisible);
  };

  document.addEventListener("click", openDrawerHandler);
  document.addEventListener("click", closeDrawerHandler);
  document.addEventListener("click", toggleFormHandler);
};

CustomerDrawer.prototype.initLoginForm = function () {
  let resetPasswordLink = document.querySelector(this.selectors.showResetPasswordLink);
  let loginLink = document.querySelector(this.selectors.showLoginFormLink);
  let loginForm = document.querySelector(this.selectors.loginForm);
  let resetPasswordForm = document.querySelector(this.selectors.resetPasswordForm);

  let loginErrorsBlock = document.querySelector(this.selectors.loginErrors);
  let resetPasswordErrorsBlock = document.querySelector(this.selectors.resetPasswordError);
  let resetPasswordSuccessBlock = document.querySelector(this.selectors.resetPasswordSuccess);
  let accountPasswordResetPageErrorsBlock = document.querySelector(this.selectors.pagePasswordError);

  if (!resetPasswordLink || !loginLink || !loginForm || !resetPasswordForm) {
    return;
  }

  resetPasswordLink.addEventListener("click", function(e) {
    e.preventDefault();
    loginForm.style.display = "none";
    resetPasswordForm.style.display = "block";
  });

  loginLink.addEventListener("click", function (e) {
    e.preventDefault();
    loginForm.style.display = "block";
    resetPasswordForm.style.display = "none";
  });

  if (loginErrorsBlock) {
    let loginDrawer = [...this.drawer.querySelectorAll(this.selectors.content)].filter((element) => {
      return element.dataset.drawerContent === "login";
    });

    if (!loginDrawer || accountPasswordResetPageErrorsBlock) {
      return;
    }

    loginDrawer[0].classList.add(this.modifiers.contentVisible);
    this.drawer.classList.add(this.modifiers.drawerOpen);
    disableBodyScroll(this.drawerScrollableContent);
  }

  if (resetPasswordErrorsBlock) {
    let loginDrawer = [...this.drawer.querySelectorAll(this.selectors.content)].filter((element) => {
      return element.dataset.drawerContent === "login";
    });

    if (!loginDrawer || accountPasswordResetPageErrorsBlock) {
      return;
    }

    loginDrawer[0].classList.add(this.modifiers.contentVisible);
    resetPasswordLink.click();
    this.drawer.classList.add(this.modifiers.drawerOpen);
    disableBodyScroll(this.drawerScrollableContent);
  }

  if (resetPasswordSuccessBlock) {
    let loginDrawer = [...this.drawer.querySelectorAll(this.selectors.content)].filter((element) => {
      return element.dataset.drawerContent === "login";
    });

    if (!loginDrawer || accountPasswordResetPageErrorsBlock) {
      return;
    }

    loginDrawer[0].classList.add(this.modifiers.contentVisible);
    resetPasswordLink.click();
    this.drawer.classList.add(this.modifiers.drawerOpen);
    disableBodyScroll(this.drawerScrollableContent);
  }
};

CustomerDrawer.prototype.initRegisterForm = function () {
  this.initPreferences();
};

CustomerDrawer.prototype.initPreferences = function () {
  let preferencesOptions = document.querySelectorAll(this.selectors.preferencesOption);
  let preferencesInput = document.querySelector(this.selectors.preferencesInput);

  if (!preferencesOptions || !preferencesInput) {
    return null;
  }

  const preferencesHandler = (event) => {
    const isOption = event.target.closest(this.selectors.preferencesOption);

    if (!isOption) {
      return null;
    }

    let selectedPreferences = [];

    preferencesOptions.forEach(option => {
      if (option.checked) {
        selectedPreferences.push(option.value);
      }
    });

    preferencesInput.value = selectedPreferences.join();
  };

  document.addEventListener("change", preferencesHandler);
};

CustomerDrawer.prototype.getOrderData = function () {
  let ordersCard = document.querySelectorAll(this.selectors.ordersCard);
  let ordersList = document.querySelectorAll(this.selectors.ordersCardList)[0];
  let containerForOrderData = document.querySelectorAll(this.selectors.containerForOrderData)[0];
  let singleOrderName = document.querySelectorAll(this.selectors.singleOrderName)[0];

  if (!ordersCard || !ordersList || !containerForOrderData) {
    return;
  }

  ordersList.addEventListener("click", (e) => {
    let orderCard = e.target.closest(this.selectors.ordersCard);

    if (!orderCard) {
      return;
    }

    e.preventDefault();
    let url = orderCard.href;
    let orderName = orderCard.dataset.orderName;

    // need clear container with single order HTML before send new request
    containerForOrderData.innerHTML = "";
    this.drawer.classList.add(this.modifiers.drawerPreloader);

    $.ajax({
      url: url,
      type: 'GET',
      beforeSend: () => {},
      success: (response) => {
        let orderHtml = response;

        if (singleOrderName) {
          singleOrderName.textContent = orderName;
        }
        containerForOrderData.insertAdjacentHTML('afterbegin', orderHtml);
      },
      error: (response) => {
        console.error('ERROR to GET related product', response);
      },
      complete: () => {
        this.drawer.classList.remove(this.modifiers.drawerPreloader);
      }
    });
  });
}

export default CustomerDrawer;
